import React, { Ref, useCallback, useEffect, useState } from 'react'
import useIsMounted from 'ismounted'

import { API } from 'lib/gravy'
import Select, { SelectProps } from 'components/ui/Select/Select'
import { IntegrationPartner } from 'types/models'

const IntegrationPartnerSelect = React.forwardRef(
  (props: SelectProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const [integrationPartners, setIntegrationPartners] = useState<IntegrationPartner[]>()
    const isMounted = useIsMounted()

    const options = useCallback(() => {
      return integrationPartners.map((lender) => {
        return { value: lender.id, text: `${lender.name}` }
      })
    }, [integrationPartners])

    useEffect(() => {
      API.get('integration_partners').then((response) => {
        if (isMounted.current) {
          setIntegrationPartners(response.data)
        }
      })
    }, [])

    if (!integrationPartners) {
      return <Select {...props} />
    }

    return (
      <div className="relative rounded-md shadow-sm w-full">
        <Select options={options()} {...props} ref={ref} />
      </div>
    )
  }
)

export default IntegrationPartnerSelect

